
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "./polyfills"
import "babel-polyfill"
import svg4everybody from 'svg4everybody'

// VUE
window.Vue = require('vue')

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import VueQrcode from '@xkeshi/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode)
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// Custom Components
import HeaderCarousel from './components/HeaderCarousel.vue'
Vue.component('headercarousel', HeaderCarousel)
import GolfHeaderCarousel from './components/GolfHeaderCarousel.vue'
Vue.component('golfheadercarousel', GolfHeaderCarousel)
import MainNav from './components/MainNav.vue'
Vue.component('main-nav', MainNav)
import ProductCarousel from './components/ProductCarousel.vue'
Vue.component('productcarousel', ProductCarousel)
import PartnersCarousel from './components/PartnersCarousel.vue'
Vue.component('partnerscarousel', PartnersCarousel)
import RestoDetailsCarousel from './components/RestoDetailsCarousel.vue'
Vue.component('restodetailscarousel', RestoDetailsCarousel)
import FooterComponent from './components/FooterComponent.vue'
Vue.component('footer-component', FooterComponent)
//import CityHeaderCarousel from './components/CityHeaderCarousel.vue'
//Vue.component('cityheadercarousel', CityHeaderCarousel)
import AccountCardsCarousel from './components/AccountCardsCarousel.vue'
Vue.component('accountcardscarousel', AccountCardsCarousel)
import AccountNavSelect from './components/AccountNavSelect.vue'
Vue.component('accountnavselect', AccountNavSelect)
import AccountCard from './components/Account/card.vue'
Vue.component('accountcard', AccountCard)
import CinemaComponent from './components/CinemaComponent.vue'
Vue.component('cinema-component', CinemaComponent)
import GolfComponent from './components/GolfComponent.vue'
Vue.component('golf-component', GolfComponent)
import RestoSelectionComponent from './components/RestoSelectionComponent.vue'
Vue.component('resto-selection-component', RestoSelectionComponent)
import PrintPage from './components/PrintPage.vue'
Vue.component('print-page', PrintPage)
import RestoDatePicker from './components/RestoDatePicker.vue'
Vue.component('restodatepicker', RestoDatePicker)

import Simulator from './components/simulator.vue'
Vue.component('simulator', Simulator)

import ModalView from './components/ModalView.vue'
Vue.component('modalview', ModalView)

// Forms
import PaymentForm from './components/forms/PaymentForm'
Vue.component('paymentform', PaymentForm)

// Inputs
import CustomSelect from './components/CustomSelect.vue'
Vue.component('custom-select', CustomSelect)
import MaskedInput from 'vue-text-mask'
Vue.component('masked-input', MaskedInput)
import RSelect from './components/forms/RSelect'
Vue.component('r-select', RSelect)
import RPhone from './components/forms/RPhone'
Vue.component('rphone', RPhone)
import RCard from './components/forms/RCard'
Vue.component('RCard', RCard)
import Privacy from './components/forms/Privacy'
Vue.component('privacy', Privacy)

// SEARCH
import PlacesAutocomplete from './components/PlacesAutocomplete.vue'
Vue.component('places-autocomplete', PlacesAutocomplete)
import PlacesSearch from './components/PlacesSearch.vue'
Vue.component('places-search', PlacesSearch)

// MAPS
var GoogleMapsLoader = require('google-maps');
GoogleMapsLoader.VERSION = '3.34';
GoogleMapsLoader.KEY = 'AIzaSyBw_Y-O_AdeF9_aYWvrA8iN1qwyLHt-Xfo';
GoogleMapsLoader.LANGUAGE = 'fr';
GoogleMapsLoader.REGION = 'BE';

require('js-marker-clusterer');

import RMap from './components/maps/RMap'
Vue.component('rmap', RMap)

// HELPERS
import ImageLoader from './components/ImageLoader.vue'
Vue.component('img-loader', ImageLoader)
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import Alert from './modules/Alert'
Alert.init()

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = window.app = new Vue({

    el: '#app',

	data: {
		scrollTop: 0,
		disabled_btn: false,
	},

	computed: {
		appClass() {}
	},

	mounted() {
		svg4everybody() // SVG FIX IE
		this.listenEvents()
		if(window.pageYOffset > 100) {
			this.sendYOffset(window.pageYOffset)
		}
	},

	methods: {

		listenEvents() {
			window.addEventListener('scroll', this.defineScroll)
			window.addEventListener('resize', this.defineResize)
		},

		defineScroll() {
			const doc = document.documentElement;
			let top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
			this.scrollTop = top
			this.$emit('scroll', top)
		},

		defineResize() {
			const w = window,
				d = document,
				e = d.documentElement,
				g = d.getElementsByTagName('body')[0];
			let width = w.innerWidth || e.clientWidth || g.clientWidth,
				height = w.innerHeight|| e.clientHeight|| g.clientHeight
			this.$emit('resize', width, height)
		},

		sendYOffset(yoffset) {
			let offset = yoffset;
			this.$emit('yoffset', offset)
		},

	}

})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js